<template>
  <div v-if="!loading" class="container-fluid new_Header">
    <div class="row nav_Breadcrumb">
      <div class="col">
        <nav>
          <ol class="breadcrumb">
            <li class="breadcrumb-item mx-3"><router-link  to="/">{{$t('propertypreview.breadcrumb_1')}}</router-link></li>
            <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
            <i  v-else class="fa-solid fa-chevron-right pt-1"></i>
            <li class="breadcrumb-item mx-3">
              <router-link :to="'/propertydetails/'+this.propertyId">
                {{$t('propertypreview.breadcrumb_2')}}
              </router-link>
            </li>
            <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
            <i  v-else class="fa-solid fa-chevron-right pt-1"></i>
            <li class="almarai-bold active mx-3" aria-current="page">{{$t('propertypreview.breadcrumb_3')}}</li>
          </ol>
        </nav>
      </div>
    </div>
  </div>
  <div class="container pt-3">
    <mainloader v-if="loading" />
    <div v-else class="row">
      <div class="col">
        <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
        <div class="row pt-3">
          <div class="col-12 mb-2">اختر نوع المعاينة:</div>
          <div class="col-12">
            <input type="radio" v-model="fancyReview" :value="false" class="btn-check" name="options-outlined" id="success-outlined" autocomplete="off" />
            <label class="btn btn-outline-secondary ms-3" for="success-outlined">{{$t('propertypreview.normal_preview')}}</label>

            <input type="radio" v-model="fancyReview" :value="true" class="btn-check" name="options-outlined" id="danger-outlined" autocomplete="off">
            <label class="btn btn-outline-success" for="danger-outlined">{{$t('propertypreview.fancy_preview')}}</label>
          </div>
        </div>

        <div v-if="fancyReview">
          <div class="row pt-2">
            <div class="col">
              <h6 class="p-content py-2">{{$t('propertypreview.location')}}:</h6>
              <div ref="myMap" style="width: 100%; height: 320px;"></div>
            </div>
          </div>
          <div class="row pt-2">
            <div class="col-12 col-md-6 pb-2">
              <label class="p-content" for="">{{$t('addAd.title_70')}}:</label>
              <input type="number" class="form-control select-style" v-model="longitude">
            </div>
            <div class="col-12 col-md-6 pb-2">
              <label class="p-content" for="">{{$t('addAd.title_71')}}:</label>
              <input type="number" class="form-control select-style" v-model="latitude">
            </div>
          </div>

          <div class="row pt-2">
            <div class="col-11 col-md-6">
              <label class="p-content" for="">{{$t('propertypreview.address')}}:</label>
              <input type="text" class="form-control select-style" v-model="address">
            </div>
          </div>
        </div>

        <div class="row pt-3">
          <div class="col">
            <vue-cal
            @cell-click ="onDateSelect"
            default-view="month"
            active-view="month"
            :disable-views="['week', 'day']" locale="ar" 
            :time="false"
            />
            
          </div>
        </div>

        <div class="row pt-3">
          <div class="col-6 col-md-2 mouse-hand">
            <div class="div-time btn-group space">
              <img src="/assets/images/icons/clock.png" class="max-width-28 mx-2" alt="">
              <label>{{$t('propertypreview.title_1')}}</label>
              <!-- <span class="mx-2"> 9 ص - 5 م </span> -->
            </div>
          </div>
          <div class="col-6 col-md-4 button-center mouse-hand">
            <select class="form-select select-time text-center fonttext-14" id="timeSelect" v-model="time">
              <option value="">{{$t('propertypreview.title_2')}}</option>
              <option v-for="(row,index) in rows" :key="index" :value="row.value">{{row.label}}</option>
            </select>
          </div>
        </div>

        <div class="row pt-4">
          <div class="col-1 text-center p-0">
            <img src="/assets/images/Frame-385.png" class="w-50" alt="">
          </div>
          <div class="col-11 button-center pe-0">
            <div>{{$t('propertypreview.title_3')}}</div>
            <div>
              {{$t('propertypreview.title_4')}}              
              <span class="green-color-F almarai-bold" >{{fancyPrice}} {{$t('currency')}} {{$t('propertypreview.only')}}</span>
            </div>
          </div>
        </div>

        <div class="row pt-2">
          <div class="col">
            <h6 class="p-content py-2">{{$t('propertypreview.preview_location')}}:</h6>
            <div ref="previewMap" style="width: 100%; height: 320px;"></div>
          </div>
        </div>

        <div v-if="!fancyReview" class="row pt-5 justify-content-center">
          <div class="col-11 col-md-4 text-center mouse-hand">
            <loader v-if="isLoading" />
            <div v-else @click="reservationCreate" class="form-control almarai-bold  submit-button" >{{$t('propertypreview.title_5')}}</div>
          </div>
        </div>
        <div v-if="fancyReview" class="row pt-3 justify-content-center">
          <div class="col-11 col-md-4 mouse-hand">
            <div @click="poupPaymentOrder" class="form-control almarai-bold btn-green">{{$t('propertypreview.title_6')}}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- begin:payment successfully confirmed pop-up -->
    <div class="modal" id="showPopup" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <div class="row justify-content-center pt-3">
              <div class="col-12 text-center">
                <img src="/assets/images/icons/true-icon.png" class="max-56" alt="">
              </div>
            </div>
            <div class="row pt-3">
              <div class="col text-center">
                <p class="almarai-bold mb-1" >{{$t('propertypreview.paymentSuccessfully')}}</p>
                <div class="fontGray-73">{{$t('propertypreview.paymentProcess')}}</div>
              </div>
            </div>
            <div class="row pt-3 justify-content-center">
              <div class="col-12 col-md-7">
                <router-link to="/">
                  <div class="btn-green almarai-bold text-center">{{$t('propertypreview.btn_backHome')}}</div>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end:payment successfully confirmed pop-up -->
    
    <!--begin:modalReservation-->
    <div v-if="item.Property && !isLoading && !loading"  class="modal hidden-Fileds bg-color-B" tabindex="-1" id="reservationForm">
      <div class="modal-dialog width-800">
        <div class="modal-content">
          <div class="modal-body">
          <div class="row justify-content-center pt-3">
            <div class="col-12 text-center">
              <div>
                <img src="/assets/images/icons/tick-circle-gold.png" class="max-56" alt="">
              </div>
              <div class="pt-2">
                <p class="successfullBooked">{{$t('propertypreview.title_7')}}</p>
              </div>
            </div>
            <div class="col-12 pb-2">
              <div class="almarai-bold">{{$t('propertypreview.title_8')}}</div>
            </div>
          </div>
          <div class="row">
            <div v-if="item.Property.Agent" class="col-12 space col-md-4">
              <span><img src="/assets/images/icons/call.png" class="img-fluid mx-2" alt=""></span>
              <span class="fonttext-14 gray-color">{{$t('propertypreview.title_9')}}</span>
              <span class="orange-font mx-2">{{ item.Property.Agent.mobile }}</span>
            </div>
            <div class="col-12 col-md-4">
              <span><img src="/assets/images/icons/location.png" class="img-fluid mx-2 gray-color" alt=""></span>
              <span class="orange-font">{{item.Property.title}}</span>
            </div>
            <div class="col-12 col-md-2">
              <span><img src="/assets/images/icons/gray-clock.png" class="img-fluid mx-2 gray-color" alt=""></span>
              <span class="fonttext-14 gray-color"> {{ item.time}} </span>
            </div>
            <div class="col-12 col-md-2 ">
              <span><img src="/assets/images/icons/calendar.png" class="img-fluid mx-2" alt=""></span>
              <span class="fonttext-14 gray-color"> {{ item.date}} </span>
            </div>
          </div>
          <div class="row py-3 justify-content-center">
            <div class="col-12 col-md-6">
              <router-link to="/">
              <div class="btn-green almarai-bold text-center">{{$t('propertypreview.title_10')}}</div>
              </router-link>
            </div>
          </div>
          </div>
        </div>
      </div>
    </div>
    <!--end:modalReservation--->

    <!-- begin:modal-payment -->
    <!-- <button type="button"  id="selectPayment" class="btn btn-primary d-none" data-bs-toggle="modal" data-bs-target="#paymentModal">
      </button>
    <div class="modal fade d-none" id="paymentModal" tabindex="-1" aria-labelledby="paymentModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header border-0 pb-1">
            <h1 class="modal-title fs-5 pt-2" id="paymentModalLabel">{{$t('wallet.title_12')}}</h1>
            <button type="button" id="closeModal" class="btn-close p-3 m-0" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          
          <div class="modal-body">
            <label for="" class="text-style">{{$t('wallet.title_13')}}</label>
            <div class="row pt-3 justify-content-center">
              <div class="col-11 position-R">
                <label for="visa" class=" mouse-hand d-block">
                  <div class="input-style">
                    <input class="form-check-input radio-left" v-model="paymentGate" type="radio" value="online" name="radioDefault" id="visa">
                    <img src="/assets/images/Frame_41.png" class="width-icon" alt="">
                    <span class="mx-2">{{$t('wallet.title_14')}}</span>
                  </div>
                </label>
              </div>
            </div>

            <div class="row pt-3 justify-content-center">
              <div class="col-11 position-R">
                <label for="radioDefault1" class=" mouse-hand d-block">
                  <div class="input-style">
                    <input class="form-check-input radio-left" v-model="paymentGate"  value="wallet" type="radio"  name="radioDefault" id="radioDefault1">
                    <img src="/assets/images/icons/img-3.png" class="width-icon" alt="">
                    <span class="mx-2">{{$t('wallet.title_16')}}</span>
                  </div>
                </label>
              </div>
            </div>
            <div class="row pt-5 justify-content-center">
              <div v-if="isLoader" class="text-center">
                <loader />
              </div>
              <div v-else class="col text-center">
                <button @click.prevent="paymentMethod" :disabled="paymentGate == ''" class="form-control padding-style almarai-bold buttonStyle">{{$t('maintenanceDetails.title_5')}} </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <!-- end:modal-payment -->

    <!-- begin:modal-payment -->
    <button type="button"  id="selectPayment" class="btn btn-primary d-none" data-bs-toggle="modal" data-bs-target="#paymentModal">
      </button>
    <div class="modal fade" id="paymentModal" tabindex="-1" aria-labelledby="paymentModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <!-- <div class="modal-header border-0 pb-1">
            <h1 class="modal-title fs-5 pt-2" id="documentModalLabel">{{$t('wallet.title_12')}}</h1>
            <button type="button" id="closeModal" class="btn-close p-3 m-0" data-bs-dismiss="modal" aria-label="Close"></button>
          </div> -->
          
          <div class="modal-body">
            <div class="row py-2">
              <div class="col almarai-bold">
                {{$t('wallet.payment')}}
              </div>
              <div class="col-auto mouse-hand" id="closeModal" data-bs-dismiss="modal" aria-label="Close">
                <i class="fa-regular fa-circle-xmark fs-5 gray-color"></i>
              </div>
            </div>

            <div class="py-2 gray-color">{{$t('wallet.choosePayment_Method')}}</div>

            <div class="row py-3" v-if="fancyPrice">
              <label class="almarai-bold mb-2">{{$t('wallet.cost')}}</label>
              <div class="col-12">
                <div class="d-flex input-style">
                  <span class="gray-color almarai-bold">{{$t('wallet.cost')}}</span>
                  <div class="direction">
                    <span class="mx-2 gray-color almarai-bold">{{fancyPrice}}</span>
                    <span>
                      <img src="/assets/images/icons/riyal.png" class="max-16" alt="">
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <label class="almarai-bold pt-2">{{$t('wallet.title_13')}}</label>
            <div class="row pt-3 justify-content-center">
              <div class="col-12 position-R">
                <label for="visa" class=" mouse-hand d-block">
                  <div :class="(paymentGate == 'online')? 'wallet-style priceList' : 'wallet-style'">
                    <input class="form-check-input radio-left select_Radio" v-model="paymentGate" type="radio" value="online" name="radioDefault" id="visa">
                    <img src="/assets/images/icons/bank.png" class="width-icon" alt="">
                    <span class="mx-2 almarai-bold">{{$t('wallet.title_14')}}</span>
                    <span class="bankCard">{{$t('wallet.bankCard')}}</span>
                  </div>
                </label>
              </div>
            </div>

            <div class="row pt-3 justify-content-center">
              <div class="col-12 position-R">
                <label for="radioDefault1" class=" mouse-hand d-block">
                  <div :class="(paymentGate == 'wallet')? 'wallet-style priceList' : 'wallet-style'">
                    <input class="form-check-input radio-left select_Radio" v-model="paymentGate"  value="wallet" type="radio"  name="radioDefault" id="radioDefault1">
                    <img src="/assets/images/icons/wallet-3.png" class="width-icon" alt="">
                    <span class="mx-2 almarai-bold">{{$t('wallet.title_16')}}</span>
                    <span class="bankCard">{{$t('wallet.appWallet')}}</span>
                  </div>
                </label>
              </div>
            </div>

            <div class="row pt-3 justify-content-center">
              <loader v-if="paymentLoading" class="text-center" />
              <div v-else class="col-11 col-md-8 text-center">
                <div @click.prevent="paymentMethod" class="form-control btn-green">{{$t('maintenanceDetails.title_5')}} </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end:modal-payment -->

    <!--begin:popup wallet balance -->
    <div class="modal bg-color-B" tabindex="-1" id="popup_WalletBalance">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header headerWallet">
            <button type="button" class="btn-close m-0" @click="closeWalletBalance" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <h6 class="modal-title text-center almarai-bold pt-3">{{$t('walletPaymentConfirmation')}}</h6>
          <div class="modal-body">
            <div class="row" v-if="paymentGate == 'wallet'">
              <div class="col-auto almarai-bold content-center">{{$t('walletBalance')}}</div>
              <div class="col text-start">
                {{USER_WALLET_BALANCE}}
                <span class="mx-1 green-color-F icon-saudi_riyal_bold_new"></span>
              </div>
            </div>

            <div class="row">
              <div class="col-auto almarai-bold content-center">{{$t('totalOrder')}}</div>
              <div class="col text-start">
                {{fancyPrice}}
                <span class="mx-1 green-color-F icon-saudi_riyal_bold_new"></span>
              </div>
            </div>

            <div class="row" v-if="paymentGate == 'wallet'">
              <div class="col-auto almarai-bold content-center">{{$t('remainingBalance')}}</div>
              <div class="col text-start">
                {{remainingBalance}}
                <span class="mx-1 green-color-F icon-saudi_riyal_bold_new"></span>
              </div>
            </div>

            <div class="row justify-content-center pt-3">
              <div v-if="min_loader" class="text-center">
                <loader />
              </div>
              <div v-else class="col text-center" @click.prevent="reservationCreate">
                <div class="btn-green">{{$t('confirmButton')}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--end:popup wallet balance -->

    <!--begin:Charge your wallet -->
    <div class="modal bg-color-B" tabindex="-1" id="chargeWallet">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header headerWallet">
            <button type="button" class="btn-close m-0" @click="closePopupCharge" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <h6 class="modal-title text-center almarai-bold pt-3">{{$t('balanceInsufficient')}}</h6>
          <div class="modal-body">
            <div class="row justify-content-center">
              <div class="col text-center">
                <div class="small-Font">{{$t('chargeWallet')}}</div>
              </div>
            </div>

            <div class="row pt-3">
              <div class="col">
                <router-link to="/wallet">
                  <div class="btn-green fonttext-14">{{$t('btnChargeWallet')}}</div>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--end:Charge your wallet -->


    <!--begin:modalAddCard-->
    <!-- <div class="modal hidden-Fileds bg-color-B" tabindex="-1" id="addcard">
      <div class="modal-dialog width-800">
        <div class="modal-content">
          <div class="modal-body">
            <div class="almarai-bold py-2">اضف بطاقتك للدفع</div>
            <errorAlert v-if="hasError" :alertMessage="message" />
            <div class="row py-2">
              <div class="col-12 position-R">
                <label for="" class="fonttext-14 gray-color">رقم البطاقة
                  <span class="orange-color">*</span>
                </label>
                <img src="/assets/images/Frame_41.png" class="logo-card" alt="">
                <input type="text" class="form-control input-style" v-model="cardNumber" >
              </div>
            </div>
            <div class="row py-3">
              <div class="col-4">
                <label for="" class="fonttext-14 gray-color">تاريخ السنة 
                  <span class="orange-color">*</span>
                </label>
                <input type="number" class="form-control input-style" v-model="year" >
              </div>
              <div class="col-4">
                <label for="" class="fonttext-14 gray-color">تاريخ الشهر 
                  <span class="orange-color">*</span>
                </label>
                <input type="number" class="form-control input-style" v-model="month" >
              </div>
              <div class="col-4">
                <label for="" class="fonttext-14 gray-color">الـ CVV
                  <span class="orange-color">*</span>
                </label>
                <input type="password" class="form-control input-style" v-model="password" >
              </div>
            </div>
            <div class="row py-3">
              <div class="col button-center">
                <input class="form-check-input" type="checkbox" v-model="checked">
                <label for="" class="fonttext-14 almarai-regular gray-color mx-2">حفظ البطاقة للاستخدام لاحقا</label>
              </div>
            </div>
            <div class="row py-3">
              <div class="col mouse-hand" @click="addPayment">
                <div class="submit-button almarai-bold text-center">اضف بطاقة جديدة</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <!--end:modalAddCard--->
    <!--begin:modalluxuryPreview-->
    <!-- <div class="modal hidden-Fileds bg-color-B" tabindex="-1" id="luxury">
      <div class="modal-dialog width-800">
        <div class="modal-content">
          <div class="modal-body">
            <div class="row py-3">
              <div class="col button-center">
                <div @click="addCardsFN" class="mouse-hand space">
                  <i class="fa-solid fa-circle-plus orange-color"></i>
                  <span class="mx-2 almarai-bold">اضف بطاقتك للدفع</span>
                </div>
              </div>
              <div class="col text-start ps-4">
                <button @click="closeModal" class="btn-close"></button>
              </div>
            </div>
            <mainloader v-if="loader" />
            <errorAlert v-if="hasError" :alertMessage="message" />
            <div class="row py-2">
              <div class="col-12 mb-2" v-for="(val,index) in cards" :key="index">
                <div class="form-check input-style position-R">
                  <label class="form-check-label" :for="val.id">
                    {{val.last}}-****-****-****
                    <input class="form-check-input check-radio" v-model="cardId" :value="val.id" name="radioDefault" type="radio"  :id="val.id">
                  </label>
                </div>
              </div>
            </div>
            <div class="row py-3">
              <div class="col-12">
                <label for="" class="fonttext-14 gray-color">الـ CVV
                  <span class="orange-color">*</span>
                </label>
                <input type="password" class="form-control input-style" v-model="password" >
              </div>
            </div>
            <div class="row py-3">
              <div class="col mouse-hand" @click="payReservation">
                <div v-if="isLoader" class="text-center">
                  <loader />
                </div>
                <div v-else class="submit-button almarai-bold text-center">حجز معاينة فاخرة بـ 500 ريال</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <!--end:modalluxuryPreview--->
    <!--begin:modal addcardSuccessful-->
    <!-- <div class="modal hidden-Fileds bg-color-B" tabindex="-1" id="addCardSuccessful">
      <div class="modal-dialog width-800">
        <div class="modal-content">
          <div class="modal-body">
            <div class="row justify-content-center pt-3">
              <div class="col-12 text-center">
                <img src="/assets/images/tick-circle.png" alt="">
              </div>
            </div>
            <div class="row py-3">
              <div class="col text-center">
                <p class="font-24 almarai-bold text-center mb-1">تم اضافة بطاقة جديدة</p>
                <div class="fonttext-14 gray-color almarai-regular">استمتع بالدفع السهل و السريع بسبب ميزة حفظ البطاقات لدينا</div>
              </div>
            </div>
            <div class="row py-3">
              <div class="col mouse-hand" @click="cardsList">
                <div class="back almarai-bold text-center">عودة الى بطاقاتي</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <!--end:modaladdcardSuccessful--->
  </div>
</template>
<script>
import VueCal from 'vue-cal';
import 'vue-cal/dist/vuecal.css';
import { mapGetters } from 'vuex';

export default {
  name: "propertypreview",
  components: { VueCal },
  data() {
    return {
      propertyId: this.$route.params.id,
      modelName: this.$route.query.model ?? 'property',
      message: "",
      hasError: false,
      errorNumber: 0,
      time: "",
      date: null,
      fancyReview: false,
      rows: [],
      loading: true,
      times: {},
      item:{},
      isLoading: false,
      cardNumber: "",
      year: "",
      month: "",
      password: "",
      checked: "",
      cards: [],
      loader: false,
      cardId: 0,
      isLoader: false,
      paymentGate: "",
      userLang: 'ar',
      remainingBalance: 0,
      latitude: null,
      longitude: null,
      address: "",
      fancyPrice: null,
      min_loader: false,
      dataRow: {},
    };
  },
  computed: {
    ...mapGetters(['USER_WALLET_BALANCE'])
  },
  methods:{
    async reservationCreate(){
      this.hasError = false;
      this.isLoading = false;
      this.loading = false;
      this.isLoader = true;
      this.min_loader = true;
      if(!this.date){
        this.message = this.$t('date_Message');
        this.hasError = true;
        window.scroll(0,0);
        return  false;
      }

      if(!this.time){
        this.message = this.$t('time_Message');
        this.hasError = true;
        window.scroll(0,0);
        return  false;
      }
      this.isLoading = true;
      await this.$http.post("/api/reservation/create",{
        propertyId: parseInt(this.propertyId),
        date: this.date,
        time: this.time,
        fancyReview: this.fancyReview,
        modelName: (this.modelName == 'exchange') ? 'Exchanges' : 'Properties',
        paymentGate: this.paymentGate,
        latitude: this.latitude,
        longitude: this.longitude,
        address: this.address,
      }).then(res => {
        // console.log(res);
        if(this.fancyReview){
          // this.item = res.data.paymentUrl;
          // this.reservationId = this.item.id;
          // window.location.href= this.item;
          if(res.data.paymentUrl){
            window.location.href = res.data.paymentUrl;
          }else{
            if(this.paymentGate == 'wallet'){
              this.closeWalletBalance();
              this.$store.dispatch('checkUser');
            }
            document.getElementById('showPopup').style.display = 'block';
          }
        }else{
          this.item = res.data.row;
          setTimeout(()=> {
            if(!this.fancyReview){
              document.getElementById('reservationForm').style.display = 'block';
            }
          },700)
          this.isLoading = false;
          this.loading = false;
          this.isLoader = false;
          this.min_loader = false;
        }
      }).catch(err => {
        // console.log(err);
        this.isLoading = false;
        this.loading = false;
        this.isLoader = false;
        // document.getElementById('luxury').style.display = 'none';
        [this.message, this.errorNumber]= this.$globalError(err, true);
        this.hasError = true;
        this.closeWalletBalance();
        window.scroll(0,0);
      })
    },

    onDateSelect(date) {
      const selectedDate = new Date(date); // Convert to Date object
      const formattedDate = selectedDate.toISOString().split('T')[0]; // Get YYYY-MM-DD format
      this.date = formattedDate;
      if(this.times[formattedDate]){
        this.rows = this.times[formattedDate];
      }else{
        this.rows = [];
      }
      // alert(`Selected Date: ${formattedDate}`);
      // console.log('Selected Date:', formattedDate);
    },

    getTime(){
      this.$http.get("/api/reservation/availableTimes/"+this.propertyId+'?model='+this.modelName).then(res =>{
        // console.log(res);
        this.times = res.data.times;
        this.fancyPrice = res.data.fancyPrice;
        this.dataRow = res.data.row;
        this.loading = false;
        this.showPreviewMap();
      }).catch(err => {
        // console.log(err);
        this.loading = false;
        this.message = this.$globalError(err);
        this.hasError = true;
      });
    },

    paymentMethodList(){
      this.loader = true;
      this.hasError = false;
      this.$http.get('/api/payments/methodsList').then(res => {
        // console.log(res);
        this.cards = res.data.paymentMethods;
        this.loader = false;
      }).catch(err => {
        // console.log(err);
        this.loader = false;
        this.message = this.$globalError(err);
        this.hasError = true;
      });
    },
    addCardsFN(){
      // document.getElementById('luxury').style.display = 'none';
      document.getElementById('addcard').style.display = 'block';
    },
    // async addPayment(){
    //   this.hasError = false;
    //   this.isLoading = true;
    //   await this.$http.post('/api/payments/addPayment',{
    //     number: this.cardNumber,
    //     expiry_month: this.month,
    //     expiry_year: this.year,
    //     cvv: this.password,
    //   }).then(res => {
    //     // console.log(res);
    //     setTimeout(()=>{
    //       document.getElementById('addCardSuccessful').style.display = 'block';
    //     },400)
    //     document.getElementById('addcard').style.display = 'none';
    //     this.isLoading = false;
    //   }).catch(err => {
    //     // console.log(err);
    //     this.isLoading = false;
    //     this.message = this.$globalError(err);
    //     this.hasError = true;
    //     window.scroll(0,0);
    //   })
    // },
    closeModal(){
      document.getElementById('luxury').style.display = 'none';
    },
    // payReservation(){
    //   this.isLoader = true;
    //   this.$http.post('/api/reservation/pay',{
    //     reservationId: this.reservationId,
    //     paymentMethodId: this.cardId,
    //     cvv : this.password,
    //   }).then(res => {
    //     // consol e.log(res);
    //     // document.getElementById('luxury').style.display = 'none';
    //     document.getElementById('reservation').style.display = 'block';
    //     this.isLoader = false;
    //   }).catch(err => {
    //     // console.log(err);
    //     this.isLoader = false;
    //     this.message = this.$globalError(err);
    //     this.hasError = true;
    //     window.scroll(0,0);
    //   });
    // },
    // cardsList(){
    //   document.getElementById('addCardSuccessful').style.display = 'none';
    //   this.paymentMethodList();
    //   // document.getElementById('luxury').style.display = 'block';
    // },

    poupPaymentOrder(){
      if(!this.date){
        this.message = this.$t('date_Message');
        this.hasError = true;
        window.scroll(0,0);
        return  false;
      }
      if(!this.time){
        this.message = this.$t('time_Message');
        this.hasError = true;
        window.scroll(0,0);
        return  false;
      }
      if(!this.latitude){
        this.message = 'برجاء تحديد الموقع الحالي';
        this.hasError = true;
        window.scroll(0,0);
        return  false;
      }
      if(!this.longitude){
        this.message = 'برجاء تحديد الموقع الحالي';
        this.hasError = true;
        window.scroll(0,0);
        return  false;
      }
      document.getElementById('selectPayment').click();
    },

    paymentMethod(){
      const paymentMethodDiv = document.getElementById('paymentModal');
      if(paymentMethodDiv && paymentMethodDiv.style.display == 'block'){
        document.getElementById('closeModal').click();
      }
      if(this.paymentGate == 'wallet'){
        this.showPopup();
      }else{
        this.reservationCreate();
      }
    },

    showPopup(){
      if(this.fancyPrice > this.USER_WALLET_BALANCE){
        document.getElementById('chargeWallet').style.display = 'block';
      }else{
        this.remainingBalance =  this.USER_WALLET_BALANCE - this.fancyPrice;
        document.getElementById('popup_WalletBalance').style.display = 'block';
      }
    },

    closeWalletBalance(){
      document.getElementById('popup_WalletBalance').style.display = 'none';
    },

    closePopupCharge(){
      document.getElementById('chargeWallet').style.display = 'none';
    },

    //function get Location user
    getLocation() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            this.longitude = position.coords.longitude;
            this.latitude = position.coords.latitude;
          },
          (err) => {
            // this.error = `Error: ${err.message}`;
            // this.getData();
          }
        );
      } else {
        // this.error = "Geolocation is not supported by this browser.";
        // this.getData();
      }
    },
    showPreviewMap(){
      if (!this.$refs.previewMap) {
        setTimeout(() => this.showPreviewMap(), 200);
        return;
      }
      if (!window.google) {
        console.error("Google Maps API is not loaded.");
        return;
      }
      
      if(!this.dataRow.latitude || !this.dataRow.longitude)
        return;
      
      const mapForPreview = new google.maps.Map(this.$refs.previewMap, {
        center: { 
          lat: parseFloat(this.dataRow.latitude), 
          lng: parseFloat(this.dataRow.longitude), 
        },
        zoom: 8,
      });
      
      // Create a Marker
      new google.maps.Marker({
        position: { 
          lat: parseFloat(this.dataRow.latitude), 
          lng: parseFloat(this.dataRow.longitude)
        },
        map: mapForPreview,
        draggable: false, 
      });
    },
    initMap(){
      if (!this.$refs.myMap) {
        setTimeout(() => this.initMap(), 200);
        return;
      }
      if (!window.google) {
        console.error("Google Maps API is not loaded.");
        return;
      }
      // Initialize Map
      
      this.map = new google.maps.Map(this.$refs.myMap, {
        center: { 
          lat: (this.latitude) ? parseFloat(this.latitude) :24.7136, 
          lng: (this.longitude) ? parseFloat(this.longitude) : 46.6753, 
        },
        zoom: 8,
      });
      
      // Create a Marker
      this.marker = new google.maps.Marker({
        position: { 
          lat: (this.latitude)? parseFloat(this.latitude) : 24.7136, 
          lng: (this.longitude) ? parseFloat(this.longitude) : 46.6753 
        },
        map: this.map,
        draggable: true, // Allow dragging the marker
      });

      // Update lat/lng when marker is moved
      this.marker.addListener("dragend", () => {
        const pos = this.marker.getPosition();
        this.latitude = pos.lat();
        this.longitude = pos.lng();
        // this.cityByLatFN();
      });

      // Click on the map to set a new marker position
      this.map.addListener("click", (event) => {
        this.latitude = event.latLng.lat();
        this.longitude = event.latLng.lng();
        this.marker.setPosition(event.latLng);
        // this.cityByLxatFN();
      });
    },
    initialGoogleMap(){
      if (!window.google) {
        const script = document.createElement("script");
        script .src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyCmKIguViZj4DtgCcT2Wv8pstx0ynuHMWg&loading=async&libraries=places&callback=initMap`
        script.async = true;
        document.head.appendChild(script);
        window.initMap = this.initMap;
      } else {
        this.initMap();
      }
    },
  },
  created(){
    this.getTime();
    this.getLocation();
    this.initialGoogleMap();
    this.userLang = localStorage.getItem('lang') ?? 'ar'; 
  }
}
</script>